import React from "react";

export type PlayCircleVariant = "idle" | "playing" | "hover" | "failed";

export interface PlayCircleProps extends React.SVGProps<SVGSVGElement> {
  variant?: PlayCircleVariant;
}

export function PlayCircle({ variant = "idle", ...svgProps }: PlayCircleProps) {
  if (variant === "failed") {
    return (
      <svg
        data-variant="failed"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...svgProps}
      >
        <g clipPath="url(#clip0_1005_4285)">
          <path
            d="M7.99992 14.6668C11.6818 14.6668 14.6666 11.6821 14.6666 8.00016C14.6666 4.31826 11.6818 1.3335 7.99992 1.3335C4.31802 1.3335 1.33325 4.31826 1.33325 8.00016C1.33325 11.6821 4.31802 14.6668 7.99992 14.6668Z"
            fill="#ff3434"
            stroke="#ff3434"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M6.66675 5.3335L10.6667 8.00016L6.66675 10.6668V5.3335Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_1005_4285">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }

  if (variant === "hover") {
    return (
      <svg
        data-variant="hover"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...svgProps}
      >
        <g clipPath="url(#clip0_1005_4285)">
          <path
            d="M7.99992 14.6668C11.6818 14.6668 14.6666 11.6821 14.6666 8.00016C14.6666 4.31826 11.6818 1.3335 7.99992 1.3335C4.31802 1.3335 1.33325 4.31826 1.33325 8.00016C1.33325 11.6821 4.31802 14.6668 7.99992 14.6668Z"
            fill="#4338CA"
            stroke="#4338CA"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M6.66675 5.3335L10.6667 8.00016L6.66675 10.6668V5.3335Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_1005_4285">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }

  if (variant === "playing") {
    return (
      <svg
        data-variant="playing"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...svgProps}
      >
        <g clipPath="url(#clip0_1005_4312)">
          <path
            d="M7.99992 14.6668C11.6818 14.6668 14.6666 11.6821 14.6666 8.00016C14.6666 4.31826 11.6818 1.3335 7.99992 1.3335C4.31802 1.3335 1.33325 4.31826 1.33325 8.00016C1.33325 11.6821 4.31802 14.6668 7.99992 14.6668Z"
            fill="#389E0D"
            stroke="#389E0D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M6.66675 5.3335L10.6667 8.00016L6.66675 10.6668V5.3335Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_1005_4312">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }

  return (
    <svg
      data-variant="idle"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <g clipPath="url(#clip0_1005_4272)">
        <path
          d="M7.99992 14.6668C11.6818 14.6668 14.6666 11.6821 14.6666 8.00016C14.6666 4.31826 11.6818 1.3335 7.99992 1.3335C4.31802 1.3335 1.33325 4.31826 1.33325 8.00016C1.33325 11.6821 4.31802 14.6668 7.99992 14.6668Z"
          stroke="#6D6D6D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M6.66675 5.3335L10.6667 8.00016L6.66675 10.6668V5.3335Z" fill="#6D6D6D" />
      </g>
      <defs>
        <clipPath id="clip0_1005_4272">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
